import { assignPrototypeAPIs, assignTableAPIs, makeStateUpdater } from "../../utils.js";
import { column_getCanGlobalFilter, table_getGlobalAutoFilterFn, table_getGlobalFilterFn, table_resetGlobalFilter, table_setGlobalFilter } from "./globalFilteringFeature.utils.js";

//#region src/features/global-filtering/globalFilteringFeature.ts
/**
* Feature that adds global filtering state, defaults, and global filter APIs.
*/
const globalFilteringFeature = {
	getInitialState: (initialState) => {
		return {
			globalFilter: void 0,
			...initialState
		};
	},
	getDefaultTableOptions: (table) => {
		return {
			onGlobalFilterChange: makeStateUpdater("globalFilter", table),
			globalFilterFn: "auto",
			getColumnCanGlobalFilter: (column) => {
				if ("enableGlobalFilter" in column.columnDef && column.columnDef.enableGlobalFilter === true) return true;
				const value = table.getCoreRowModel().flatRows.find((row) => row.getAllCellsByColumnId()[column.id]?.getValue() != null)?.getAllCellsByColumnId()[column.id]?.getValue();
				return typeof value === "string" || typeof value === "number";
			}
		};
	},
	assignColumnPrototype: (prototype, table) => {
		assignPrototypeAPIs("globalFilteringFeature", prototype, table, { column_getCanGlobalFilter: { fn: (column) => column_getCanGlobalFilter(column) } });
	},
	constructTableAPIs: (table) => {
		assignTableAPIs("globalFilteringFeature", table, {
			table_getGlobalAutoFilterFn: { fn: () => table_getGlobalAutoFilterFn() },
			table_getGlobalFilterFn: { fn: () => table_getGlobalFilterFn(table) },
			table_setGlobalFilter: { fn: (updater) => table_setGlobalFilter(table, updater) },
			table_resetGlobalFilter: { fn: (defaultState) => table_resetGlobalFilter(table, defaultState) }
		});
	}
};

//#endregion
export { globalFilteringFeature };